import { all } from "redux-saga/effects";
import { authSaga } from "./saga/authSaga";
import { signSaga } from "./saga/signSaga";
import { otpAuthSaga } from "./saga/otpAuthSaga";
import { feedbackSaga } from "./saga/feedbackSaga";
import { guestAuthSaga } from "./saga/guestAuthSaga";
import { chatSessionSaga } from "./saga/chatSessionSaga";
import { chatSessionHistorySaga } from "./saga/chatSessionHistorySaga";
import { chatSaga } from "./saga/chatSaga";
import { userProfileSaga } from "./saga/userProfileSaga";
import { deleteAccountSaga } from "./saga/deleteAccountSaga";
import { deleteChatSaga } from "./saga/deleteChatSaga";
import { renameTitleSaga } from "./saga/renameTitleSaga";
import { deleteChatSessionSaga } from "./saga/deleteChatSessionSaga";
import { getBookmarkSaga } from "./saga/getBookmarkSaga";
import { createBookmarkSaga } from "./saga/createBookmarkSaga";
import { deleteBookmarkSaga } from "./saga/deleteBookmarkSaga";
import { updateBookmarkSaga } from "./saga/updateBookmarkSaga";
import { consentSaga } from "./saga/consentSaga";

export function* rootSaga() {
    yield all([
        authSaga(),
        signSaga(),
        otpAuthSaga(),
        feedbackSaga(),
        guestAuthSaga(),
        chatSessionSaga(),
        getBookmarkSaga(),
        createBookmarkSaga(),
        deleteBookmarkSaga(),
        updateBookmarkSaga(),
        chatSessionHistorySaga(),
        chatSaga(),
        userProfileSaga(),
        deleteAccountSaga(),
        deleteChatSaga(),
        renameTitleSaga(),
        deleteChatSessionSaga(),
        consentSaga(),
    ]);
}
